export default __webpack_public_path__ + "static/media/arup_red.dc557364.svg";